$(document).ready(function() {
  $("#lead-form-mini-submit-btn").click(function( event ) {
    event.preventDefault();

    $('#lead-form-mini').addClass('d-none');
    $('#spinner').removeClass('d-none');

    var data = ""
    data = data + "&zip_codes=" + $('#zipcode')[0].value;
    data = data + "&distance=" + $('#radius')[0].value;
    data = data + "&min_asking_price=" + $('#min-price')[0].value;
    data = data + "&max_asking_price=" + $('#max-price')[0].value;
    data = data + "&search_type=zip_codes";
    data = data + "&count_only=true";

    $.ajax({
      type: "POST",
      url: window.leadApiUrl,
      data: data,
      timeout: 5000,
      headers: {
        "Authorization": window.leadApiToken
      },
      success: function(data, textStatus) {
        var total_count = data['meta']['total'];
        $('#one-week-leads').html(Math.floor(total_count/12).toLocaleString('en-US'));
        $('#lead-form-mini').addClass('d-none');
        $('#spinner').addClass('d-none');
        $('#results').removeClass('d-none');
      },
      error: function(error) {
        $('#spinner').addClass('d-none');
        $('#error').removeClass('d-none');
      }
    })
  });
});
